<template>
  <div v-if="branches && conveyancers">
    <h1>Email signature</h1>
    <v-select
      label="Choose branch"
      v-model="branchid"
      :items="branches"
      item-value="id"
      item-text="name"
      @change="updateChanged()"
      outline
    >
      <template slot="append-outer" v-if="branchid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a
              @click="
                branchid = null;
                updateChanged();
              "
              v-on="on"
            >
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Clear branch</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-select
      label="Choose conveyancer"
      v-model="conveyancerid"
      :items="conveyancers"
      item-value="id"
      @change="updateChanged()"
      outline
    >
      <template slot="selection" slot-scope="data">{{
        nameFormatted(data.item)
      }}</template>
      <template slot="item" slot-scope="data">{{
        nameFormatted(data.item)
      }}</template>
      <template slot="append-outer" v-if="conveyancerid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a
              @click="
                conveyancerid = null;
                updateChanged();
              "
              v-on="on"
            >
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Clear conveyancer</span>
        </v-tooltip>
      </template>
    </v-select>
    <div v-if="emailSignature">
      <div class="ajaxForm">
        <span v-html="emailSignature.html" />
        <span v-html="emailSignature.htmlPromotion" />
        <span v-html="emailSignature.htmlWarnings" />
      </div>
      <div class="ajaxForm">
        <span style="white-space: pre-wrap">{{ emailSignature.text }}</span>
        <span style="white-space: pre-wrap">{{
          emailSignature.textPromotion
        }}</span>
        <span style="white-space: pre-wrap">{{
          emailSignature.textWarnings
        }}</span>
      </div>
      <v-btn @click="saveEmailSignature"> <v-icon>save</v-icon>Save </v-btn>
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { nameFormatted } from "@/util/helpers";
export default {
  name: "EmailSignature",
  metaInfo() {
    return {
      title: "Email signature",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      branches: [],
      branchid: null,
      conveyancers: [],
      conveyancerid: null,
      emailSignature: null
    };
  },
  methods: {
    async fetchBranches() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/1/entities`
      );
      // console.log(response.data);
      this.branches = response.data;
    },
    async fetchConveyancers() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/2/entities`
      );
      // console.log(response.data);
      this.conveyancers = response.data;
    },
    async fetchEmailSignature() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/${this.conveyancerid}/emailSignature/branches/${this.branchid}`
      );
      // console.log(response.data);
      this.emailSignature = response.data;
    },
    updateChanged() {
      if (this.conveyancerid && this.branchid) {
        this.fetchEmailSignature();
      } else {
        this.emailSignature = null;
      }
    },
    nameFormatted(entity) {
      return entity ? nameFormatted(entity.name, "index") : "Not set";
    },
    async saveEmailSignature() {
      await nbmlaw.put(
        `/cors/admin/directory/entities/${this.conveyancerid}/emailSignature/branches/${this.branchid}`,
        null
      );
      // console.log(response.data);
      this.$router.push({
        name: "entity",
        params: { id: this.conveyancerid }
      });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.conveyancerid = Number(this.$route.params.id);
      }
    }
  },
  created() {
    this.fetchBranches();
    this.fetchConveyancers();
  }
};
</script>
